export const licenseKey =
  "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjY2MmFjNmU0LWMyZTgtNDIxOC05MWY5LTI0ZTRiZjk1NTRhZSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.wQncegyd7yWOU5rVNilPJdvCaoMWe5d+bJTEuogPHQVku0ETIed0q48UeBnGy1oy6taAWFvWjeOzx0gW8+k3eRnz8RZXTA9WE0uIhPz4yztt9ywm92kl07b5rDhjnboeIyJiUQ==";
